// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BerthMap Component Styles - Homepage Map */

.berth-map-wrapper {
  width: 100%;
}

.berth-counter {
  padding: 16px 0;
}

.search-box-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.map-container {
  position: relative;
  width: 100%;
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.berth-map {
  width: 100%;
  height: 100%;
}

.berth-marker {
  cursor: default;
  transition: transform 0.2s ease;
}

.berth-marker:hover {
  transform: scale(1.1);
}

.map-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  border-radius: 8px;
}

/* Mapbox controls styling */
.mapboxgl-ctrl-top-right {
  top: 10px;
  right: 10px;
}

/* Responsive Design */
@media (max-width: 960px) {
  .map-container {
    height: 500px;
  }

  .search-box-container {
    max-width: 100%;
    padding: 0 16px;
  }

  .berth-counter {
    padding: 12px 0;
  }
}

@media (max-width: 600px) {
  .map-container {
    height: 400px;
    border-radius: 4px;
  }

  .berth-counter {
    padding: 10px 0;
  }

  .berth-counter h6 {
    font-size: 14px;
  }

  .search-box-container {
    padding: 0 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/berthMap/BerthMap.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,SAAS;EACT,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* BerthMap Component Styles - Homepage Map */\n\n.berth-map-wrapper {\n  width: 100%;\n}\n\n.berth-counter {\n  padding: 16px 0;\n}\n\n.search-box-container {\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.map-container {\n  position: relative;\n  width: 100%;\n  height: 600px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.berth-map {\n  width: 100%;\n  height: 100%;\n}\n\n.berth-marker {\n  cursor: default;\n  transition: transform 0.2s ease;\n}\n\n.berth-marker:hover {\n  transform: scale(1.1);\n}\n\n.map-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.8);\n  z-index: 1000;\n  border-radius: 8px;\n}\n\n/* Mapbox controls styling */\n.mapboxgl-ctrl-top-right {\n  top: 10px;\n  right: 10px;\n}\n\n/* Responsive Design */\n@media (max-width: 960px) {\n  .map-container {\n    height: 500px;\n  }\n\n  .search-box-container {\n    max-width: 100%;\n    padding: 0 16px;\n  }\n\n  .berth-counter {\n    padding: 12px 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .map-container {\n    height: 400px;\n    border-radius: 4px;\n  }\n\n  .berth-counter {\n    padding: 10px 0;\n  }\n\n  .berth-counter h6 {\n    font-size: 14px;\n  }\n\n  .search-box-container {\n    padding: 0 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
